import { render, staticRenderFns } from "./AllocateErrorDialog.vue?vue&type=template&id=12a4fc70&scoped=true&lang=pug&"
import script from "./AllocateErrorDialog.vue?vue&type=script&lang=ts&"
export * from "./AllocateErrorDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a4fc70",
  null
  
)

export default component.exports